export default __webpack_public_path__ + "static/hero-badge-mobile-9eefb590606983c03aae4b5c0282fabe.webp";